// Angular
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// RxJS
import { finalize, takeUntil, tap } from 'rxjs/operators';
// Translate
import { TranslateService } from '@ngx-translate/core';
// NGRX
import { Store } from '@ngrx/store';
import { AppState } from '../../../../core/reducers';
// Auth
import { UserService } from '../../../../views/pages/services/user.service';
import { AuthNoticeService, AuthService, Register, User } from '../../../../core/auth/';
import { Subject } from 'rxjs';
import { ConfirmPasswordValidator } from './confirm-password.validator';
import { TypesUtilsService } from '../../../../core/_base/crud';
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'kt-register',
	templateUrl: './register.component.html',
	encapsulation: ViewEncapsulation.None
})
export class RegisterComponent implements OnInit, OnDestroy {
	registerForm: FormGroup;
	loading = false;
	errors: any = [];
	selectedCountry: string;
	countries: any[] = [];

	private unsubscribe: Subject<any>; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

	/**
	 * Component constructor
	 *
	 * @param authNoticeService: AuthNoticeService
	 * @param translate: TranslateService
	 * @param router: Router
	 * @param auth: AuthService
	 * @param store: Store<AppState>
	 * @param fb: FormBuilder
	 * @param cdr
	 */
	constructor(
		private userService: UserService,
		private authNoticeService: AuthNoticeService,
		private translate: TranslateService,
		private router: Router,
		private auth: AuthService,
		private store: Store<AppState>,
		private fb: FormBuilder,
		private cdr: ChangeDetectorRef,
		private typeUtil: TypesUtilsService,
		private toastr: ToastrService
	) {
		this.unsubscribe = new Subject();
	}

	/*
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	*/

	/**
	 * On init
	 */
	ngOnInit() {
		this.initRegisterForm();
		this.countries = [
			{ name: 'Afghanistan', value: 'Afghanistan', code: 'af' },{ name: 'Albania', value: 'Albania', code: 'al' },{ name: 'Algeria', value: 'Algeria', code: 'dz' },{ name: 'Andorra', value: 'Andorra', code: 'ad' },{ name: 'Angola', value: 'Angola', code: 'ao' },{ name: 'Antigua and Barbuda', value: 'AntiguaBarbuda', code: 'ag' },{ name: 'Argentina', value: 'Argentina', code: 'ar' },{ name: 'Armenia', value: 'Armenia', code: 'am' },{ name: 'Australia', value: 'Australia', code: 'au' },{ name: 'Austria', value: 'Austria', code: 'at' },{ name: 'Azerbaijan', value: 'Azerbaijan', code: 'az' },{ name: 'Bahamas', value: 'Bahamas', code: 'bs' },{ name: 'Bahrain', value: 'Bahrain', code: 'bh' },{ name: 'Bangladesh', value: 'Bangladesh', code: 'bd' },{ name: 'Barbados', value: 'Barbados', code: 'bb' },{ name: 'Belarus', value: 'Belarus', code: 'by' },{ name: 'Belgium', value: 'Belgium', code: 'be' },{ name: 'Belize', value: 'Belize', code: 'bz' },{ name: 'Benin', value: 'Benin', code: 'bj' },{ name: 'Bhutan', value: 'Bhutan', code: 'bt' },{ name: 'Bolivia', value: 'Bolivia', code: 'bo' },{ name: 'Bosnia and Herzegovina', value: 'BosniaHerzegovina', code: 'ba' },{ name: 'Botswana', value: 'Botswana', code: 'bw' },{ name: 'Brazil', value: 'Brazil', code: 'br' },{ name: 'Brunei', value: 'Brunei', code: 'bn' },{ name: 'Bulgaria', value: 'Bulgaria', code: 'bg' },{ name: 'Burkina Faso', value: 'BurkinaFaso', code: 'bf' },{ name: 'Burundi', value: 'Burundi', code: 'bi' },{ name: 'Cambodia', value: 'Cambodia', code: 'kh' },{ name: 'Cameroon', value: 'Cameroon', code: 'cm' },{ name: 'Canada', value: 'Canada', code: 'ca' },{ name: 'Cape Verde', value: 'CapeVerde', code: 'cv' },{ name: 'Central African Republic', value: 'CentralAfricanRepublic', code: 'cf' },{ name: 'Chad', value: 'Chad', code: 'td' },{ name: 'Chile', value: 'Chile', code: 'cl' },{ name: 'China', value: 'China', code: 'cn' },{ name: 'Colombia', value: 'Colombia', code: 'co' },{ name: 'Comoros', value: 'Comoros', code: 'km' },{ name: 'Congo', value: 'Congo', code: 'cg' },{ name: 'Democratic Republic of the Congo', value: 'DR Congo', code: 'cd' },{ name: 'Costa Rica', value: 'CostaRica', code: 'cr' },{ name: 'Ivory Coast', value: 'IvoryCoast', code: 'ci' },{ name: 'Croatia', value: 'Croatia', code: 'hr' },{ name: 'Cuba', value: 'Cuba', code: 'cu' },{ name: 'Cyprus', value: 'Cyprus', code: 'cy' },{ name: 'Czech Republic', value: 'CzechRepublic', code: 'cz' },{ name: 'Denmark', value: 'Denmark', code: 'dk' },{ name: 'Djibouti', value: 'Djibouti', code: 'dj' },{ name: 'Dominica', value: 'Dominica', code: 'dm' },{ name: 'Dominican Republic', value: 'DominicanRepublic', code: 'do' },{ name: 'East Timor (Timor-Leste)', value: 'EastTimor', code: 'tl' },{ name: 'Ecuador', value: 'Ecuador', code: 'ec' },{ name: 'Egypt', value: 'Egypt', code: 'eg' },{ name: 'El Salvador', value: 'ElSalvador', code: 'sv' },{ name: 'Equatorial Guinea', value: 'EquatorialGuinea', code: 'gq' },{ name: 'Eritrea', value: 'Eritrea', code: 'er' },{ name: 'Estonia', value: 'Estonia', code: 'ee' },{ name: 'Ethiopia', value: 'Ethiopia', code: 'et' },{ name: 'Fiji', value: 'Fiji', code: 'fj' },{ name: 'Finland', value: 'Finland', code: 'fi' },{ name: 'France', value: 'France', code: 'fr' },{ name: 'Gabon', value: 'Gabon', code: 'ga' },{ name: 'Gambia', value: 'Gambia', code: 'gm' },
			{ name: 'Georgia', value: 'Georgia', code: 'ge' },{ name: 'Germany', value: 'Germany', code: 'de' },{ name: 'Ghana', value: 'Ghana', code: 'gh' },{ name: 'Greece', value: 'Greece', code: 'gr' },{ name: 'Grenada', value: 'Grenada', code: 'gd' },{ name: 'Guatemala', value: 'Guatemala', code: 'gt' },{ name: 'Guinea', value: 'Guinea', code: 'gn' },{ name: 'Guinea-Bissau', value: 'GuineaBissau', code: 'gw' },{ name: 'Guyana', value: 'Guyana', code: 'gy' },{ name: 'Haiti', value: 'Haiti', code: 'ht' },{ name: 'Honduras', value: 'Honduras', code: 'hn' },{ name: 'Hungary', value: 'Hungary', code: 'hu' },{ name: 'Iceland', value: 'Iceland', code: 'is' },{ name: 'India', value: 'India', code: 'in' },{ name: 'Indonesia', value: 'Indonesia', code: 'id' },{ name: 'Iran', value: 'Iran', code: 'ir' },{ name: 'Iraq', value: 'Iraq', code: 'iq' },{ name: 'Ireland', value: 'Ireland', code: 'ie' },{ name: 'Israel', value: 'Israel', code: 'il' },{ name: 'Italy', value: 'Italy', code: 'it' },{ name: 'Jamaica', value: 'Jamaica', code: 'jm' },{ name: 'Japan', value: 'Japan', code: 'jp' },{ name: 'Jordan', value: 'Jordan', code: 'jo' },{ name: 'Kazakhstan', value: 'Kazakhstan', code: 'kz' },{ name: 'Kenya', value: 'Kenya', code: 'ke' },{ name: 'Kiribati', value: 'Kiribati', code: 'ki' },{ name: 'North Korea', value: 'NorthKorea', code: 'kp' },{ name: 'South Korea', value: 'SouthKorea', code: 'kr' },{ name: 'Kosovo', value: 'Kosovo', code: 'xk' },{ name: 'Kuwait', value: 'Kuwait', code: 'kw' },{ name: 'Kyrgyzstan', value: 'Kyrgyzstan', code: 'kg' },{ name: 'Laos', value: 'Laos', code: 'la' },{ name: 'Latvia', value: 'Latvia', code: 'lv' },{ name: 'Lebanon', value: 'Lebanon', code: 'lb' },{ name: 'Lesotho', value: 'Lesotho', code: 'ls' },{ name: 'Liberia', value: 'Liberia', code: 'lr' },{ name: 'Libya', value: 'Libya', code: 'ly' },{ name: 'Liechtenstein', value: 'Liechtenstein', code: 'li' },{ name: 'Lithuania', value: 'Lithuania', code: 'lt' },{ name: 'Luxembourg', value: 'Luxembourg', code: 'lu' },{ name: 'North Macedonia (formerly Macedonia)', value: 'NorthMacedonia', code: 'mk' },{ name: 'Madagascar', value: 'Madagascar', code: 'mg' },{ name: 'Malawi', value: 'Malawi', code: 'mw' },{ name: 'Malaysia', value: 'Malaysia', code: 'my' },{ name: 'Maldives', value: 'Maldives', code: 'mv' },{ name: 'Mali', value: 'Mali', code: 'ml' },{ name: 'Malta', value: 'Malta', code: 'mt' },{ name: 'Marshall Islands', value: 'MarshallIslands', code: 'mh' },{ name: 'Mauritania', value: 'Mauritania', code: 'mr' },
			{ name: 'Mauritius', value: 'Mauritius', code: 'mu' },{ name: 'Mexico', value: 'Mexico', code: 'mx' },{ name: 'Micronesia', value: 'Micronesia', code: 'fm' },{ name: 'Moldova', value: 'Moldova', code: 'md' },{ name: 'Monaco', value: 'Monaco', code: 'mc' },{ name: 'Mongolia', value: 'Mongolia', code: 'mn' },{ name: 'Montenegro', value: 'Montenegro', code: 'me' },{ name: 'Morocco', value: 'Morocco', code: 'ma' },{ name: 'Mozambique', value: 'Mozambique', code: 'mz' },{ name: 'Myanmar (Burma)', value: 'Myanmar', code: 'mm' },{ name: 'Namibia', value: 'Namibia', code: 'na' },{ name: 'Nauru', value: 'Nauru', code: 'nr' },{ name: 'Nepal', value: 'Nepal', code: 'np' },{ name: 'Netherlands', value: 'Netherlands', code: 'nl' },{ name: 'New Zealand', value: 'NewZealand', code: 'nz' },{ name: 'Nicaragua', value: 'Nicaragua', code: 'ni' },{ name: 'Niger', value: 'Niger', code: 'ne' },{ name: 'Nigeria', value: 'Nigeria', code: 'ng' },{ name: 'Norway', value: 'Norway', code: 'no' },{ name: 'Oman', value: 'Oman', code: 'om' },{ name: 'Pakistan', value: 'Pakistan', code: 'pk' },{ name: 'Palau', value: 'Palau', code: 'pw' },{ name: 'Panama', value: 'Panama', code: 'pa' },{ name: 'Papua New Guinea', value: 'PapuaNewGuinea', code: 'pg' },{ name: 'Paraguay', value: 'Paraguay', code: 'py' },{ name: 'Peru', value: 'Peru', code: 'pe' },{ name: 'Philippines', value: 'Philippines', code: 'ph' },{ name: 'Poland', value: 'Poland', code: 'pl' },{ name: 'Portugal', value: 'Portugal', code: 'pt' },{ name: 'Qatar', value: 'Qatar', code: 'qa' },{ name: 'Romania', value: 'Romania', code: 'ro' },{ name: 'Russia', value: 'Russia', code: 'ru' },{ name: 'Rwanda', value: 'Rwanda', code: 'rw' },{ name: 'Saint Kitts and Nevis', value: 'SaintKittsNevis', code: 'kn' },
			{ name: 'Saint Lucia', value: 'SaintLucia', code: 'lc' },{ name: 'Saint Vincent and the Grenadines', value: 'SaintVincentGrenadines', code: 'vc' },{ name: 'Samoa', value: 'Samoa', code: 'ws' },{ name: 'San Marino', value: 'SanMarino', code: 'sm' },{ name: 'Sao Tome and Principe', value: 'SaoTomePrincipe', code: 'st' },{ name: 'Saudi Arabia', value: 'SaudiArabia', code: 'sa' },{ name: 'Senegal', value: 'Senegal', code: 'sn' },{ name: 'Serbia', value: 'Serbia', code: 'rs' },{ name: 'Seychelles', value: 'Seychelles', code: 'sc' },{ name: 'Sierra Leone', value: 'SierraLeone', code: 'sl' },{ name: 'Singapore', value: 'Singapore', code: 'sg' },{ name: 'Slovakia', value: 'Slovakia', code: 'sk' },{ name: 'Slovenia', value: 'Slovenia', code: 'si' },{ name: 'Solomon Islands', value: 'SolomonIslands', code: 'sb' },{ name: 'Somalia', value: 'Somalia', code: 'so' },{ name: 'South Africa', value: 'SouthAfrica', code: 'za' },{ name: 'South Sudan', value: 'SouthSudan', code: 'ss' },{ name: 'Spain', value: 'Spain', code: 'es' },{ name: 'Sri Lanka', value: 'SriLanka', code: 'lk' },{ name: 'Sudan', value: 'Sudan', code: 'sd' },{ name: 'Suriname', value: 'Suriname', code: 'sr' },{ name: 'Eswatini', value: 'Eswatini', code: 'sz' },{ name: 'Sweden', value: 'Sweden', code: 'se' },{ name: 'Switzerland', value: 'Switzerland', code: 'ch' },{ name: 'Syria', value: 'Syria', code: 'sy' },{ name: 'Taiwan', value: 'Taiwan', code: 'tw' },{ name: 'Tajikistan', value: 'Tajikistan', code: 'tj' },{ name: 'Tanzania', value: 'Tanzania', code: 'tz' },{ name: 'Thailand', value: 'Thailand', code: 'th' },{ name: 'Togo', value: 'Togo', code: 'tg' },{ name: 'Tonga', value: 'Tonga', code: 'to' },{ name: 'Trinidad and Tobago', value: 'TrinidadTobago', code: 'tt' },{ name: 'Tunisia', value: 'Tunisia', code: 'tn' },{ name: 'Turkey', value: 'Turkey', code: 'tr' },{ name: 'Turkmenistan', value: 'Turkmenistan', code: 'tm' },{ name: 'Tuvalu', value: 'Tuvalu', code: 'tv' },{ name: 'Uganda', value: 'Uganda', code: 'ug' },{ name: 'Ukraine', value: 'Ukraine', code: 'ua' },{ name: 'United Arab Emirates', value: 'UAE', code: 'ae' },{ name: 'United Kingdom', value: 'UK', code: 'gb' },{ name: 'United States', value: 'USA', code: 'us' },{ name: 'Uruguay', value: 'Uruguay', code: 'uy' },{ name: 'Uzbekistan', value: 'Uzbekistan', code: 'uz' },{ name: 'Vanuatu', value: 'Vanuatu', code: 'vu' },{ name: 'Vatican City', value: 'VaticanCity', code: 'va' },{ name: 'Venezuela', value: 'Venezuela', code: 've' },{ name: 'Vietnam', value: 'Vietnam', code: 'vn' },{ name: 'Yemen', value: 'Yemen', code: 'ye' },{ name: 'Zambia', value: 'Zambia', code: 'zm' },{ name: 'Zimbabwe', value: 'Zimbabwe', code: 'zw' },
		];
		this.selectedCountry = ''; 
		this.registerForm.get('country').valueChanges
			.pipe(takeUntil(this.unsubscribe))
			.subscribe((selectedCountry: string) => {
				this.selectedCountry = selectedCountry;
				if (selectedCountry === 'Australia') {
					this.registerForm.get('employedByDistributionCompany').setValue(true);
					this.registerForm.get('distributorCompanyName').setValue('Eltech');
					this.registerForm.get('distributorCompanyName').disable();
				}
				else if (selectedCountry === 'NewZealand') {
					this.registerForm.get('employedByDistributionCompany').setValue(true);
					this.registerForm.get('distributorCompanyName').setValue('ECS');
					this.registerForm.get('distributorCompanyName').disable();
				}
				else {
					this.registerForm.get('employedByDistributionCompany').setValue(false);
					this.registerForm.get('distributorCompanyName').setValue('');
					this.registerForm.get('distributorCompanyName').enable();
				}
			});
	}

	/*
	* On destroy
	*/
	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
		this.loading = false;
	}

	/**
	 * Form initalization
	 * Default params, validators
	 */
	initRegisterForm() {
		this.registerForm = this.fb.group({
			fullname: ['', Validators.compose([
				Validators.required,
				Validators.minLength(3),
				Validators.maxLength(100)
			])
			],
			email: ['', Validators.compose([
				Validators.required,
				Validators.email,
				Validators.minLength(3),
				// https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
				Validators.maxLength(320)
			]),
			],
			username: ['', Validators.compose([
				Validators.required,
				Validators.minLength(3),
				Validators.maxLength(100)
			]),
			],
			country: ['', Validators.compose([
				Validators.required,
				Validators.minLength(3),
				Validators.maxLength(100)
			]),
			],
			password: ['', Validators.compose([
				Validators.required,
				Validators.minLength(3),
				Validators.maxLength(100)
			])
			],
			confirmPassword: ['', Validators.compose([
				Validators.required,
				Validators.minLength(3),
				Validators.maxLength(100)
			])
			],
			employedByDistributionCompany: [false],
			distributorCompanyName: [''],
			directlyBuyFromKIKBLOX: [false],
			agree: [false, Validators.compose([Validators.required])],
			
		}, {
			validator: ConfirmPasswordValidator.MatchPassword
		});
	}

	/**
	 * Form Submit
	 */
	submit() {
		const controls = this.registerForm.controls;

		// check form
		if (this.registerForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return;
		}

		this.loading = true;

		if (!controls.agree.value) {
			// you must agree the terms and condition
			// checkbox cannot work inside mat-form-field https://github.com/angular/material2/issues/7891
			this.authNoticeService.setNotice('You must agree the terms and condition', 'danger');
			return;
		}
		const _user: User = new User();
		_user.clear();
		_user.uuid = this.typeUtil.generateUUID();
		_user.priceStatus = 0;
		_user.email = controls.email.value;
		_user.username = controls.username.value;
		_user.fullname = controls.fullname.value;
		_user.country = this.selectedCountry;
		_user.password = controls.password.value;
		_user.distributorCompanyName = controls.distributorCompanyName.value;
		_user.isDirectCustomer = controls.directlyBuyFromKIKBLOX.value;
		_user.roles = [];
		//console.log(controls.password.value);
		this.userService.createUser(_user).subscribe(res => {
			this.toastr.success('User registered successfully!');	
			this.authNoticeService.setNotice(this.translate.instant('AUTH.REGISTER.SUCCESS'), 'success');
			this.router.navigateByUrl('/user-management/users');
			//this.subscriptions.push(res);
			
		},


			err => {
				this.toastr.error('User email is already taken. Please choose another email.');
				this.authNoticeService.setNotice(this.translate.instant('AUTH.VALIDATION.INVALID_LOGIN'), 'danger');
				
				console.log(err)


			})




		/*this.auth.register(_user).pipe(
			tap(user => {
				if (user) {
					this.store.dispatch(new Register({authToken: user.accessToken}));
					// pass notice message to the login page
					this.authNoticeService.setNotice(this.translate.instant('AUTH.REGISTER.SUCCESS'), 'success');
					this.router.navigateByUrl('/auth/login');
				} else {
					this.authNoticeService.setNotice(this.translate.instant('AUTH.VALIDATION.INVALID_LOGIN'), 'danger');
				}
			}),
			takeUntil(this.unsubscribe),
			finalize(() => {
				this.loading = false;
				this.cdr.markForCheck();
			})
		).subscribe();
		*/
	}

	/**
	 * Checking control validation
	 *
	 * @param controlName: string => Equals to formControlName
	 * @param validationType: string => Equals to valitors name
	 */
	isControlHasError(controlName: string, validationType: string): boolean {
		const control = this.registerForm.controls[controlName];
		if (!control) {
			return false;
		}

		const result = control.hasError(validationType) && (control.dirty || control.touched);
		return result;
	}
}
